import { DocLayout } from './DocLayout';

export default function DocActivitati() {
  return (
    <DocLayout title="Activități">
      <h2>Prezentare generală</h2>
      <p>
        Pagina de activități este centrul de gestionare al tuturor evenimentelor și activităților din platformă.
        De aici poți crea activități noi, edita cele existente, publica sau retrage activități, și exporta datele.
      </p>

      <h2>Lista de activități</h2>
      <p>Lista afișează toate activitățile, indiferent de status. Poți:</p>
      <ul>
        <li><strong>Căuta</strong> — folosește bara de căutare pentru a filtra după titlu.</li>
        <li><strong>Filtra după status</strong> — alege între Toate, Publicate sau Draft.</li>
        <li><strong>Vizualiza în calendar</strong> — comută între vizualizarea listă și cea de calendar lunar.</li>
        <li><strong>Publica/Retrage</strong> — folosește toggle-ul de status direct din tabel.</li>
        <li><strong>Exporta CSV</strong> — descarcă un fișier CSV cu toate activitățile.</li>
      </ul>

      <h3>Coloane tabel</h3>
      <ul>
        <li><strong>Titlu</strong> — numele activității.</li>
        <li><strong>Data</strong> — data și ora de start.</li>
        <li><strong>Tag-uri</strong> — primele 3 tag-uri asociate.</li>
        <li><strong>Înscriși</strong> — numărul de participanți înregistrați (ex: 5/100). Apare doar pentru activitățile cu înregistrare internă.</li>
        <li><strong>Status</strong> — Publicat sau Draft, cu toggle rapid.</li>
        <li><strong>Acțiuni</strong> — Participanți (dacă are înregistrare internă), Editează, Șterge.</li>
      </ul>

      <h2>Creare și editare</h2>
      <p>Formularul de activitate conține mai multe secțiuni:</p>

      <h3>Informații de bază</h3>
      <p>Titlu (obligatoriu), date de start/final, locație text și locație pe hartă, banner (imagine).</p>

      <h3>Descriere</h3>
      <p>Suportă format <a href="/staff/documentatie/markdown">Markdown</a>. Folosește butonul de previzualizare pentru a vedea cum va arăta.</p>

      <h3>Tag-uri</h3>
      <p>Selectează tag-uri principale (categorii) și tag-uri secundare. Tag-urile principale apar cu culoarea lor pe pagina publică.</p>

      <h3>Prieteni</h3>
      <p>Adaugă prieteni organizatori cu date de contact opționale pentru fiecare. Prietenii trebuie să existe în sistem.</p>

      <h3>Contacte activitate</h3>
      <p>Persoane de contact afișate pe pagina publică a activității (independente de prieteni).</p>

      <h3>Înregistrare și Limite</h3>
      <ul>
        <li><strong>Limită participanți</strong> — opțional. Dacă e setat, înregistrările se opresc la atingerea limitei.</li>
        <li><strong>Vârstă minimă/maximă</strong> — restricții de vârstă afișate pe pagina publică.</li>
        <li><strong>Minorii necesită adult</strong> — afișează un avertisment pe pagina publică.</li>
        <li><strong>Necesită înregistrare</strong> — activează formularul de înregistrare.</li>
      </ul>

      <h3>Tipul de înregistrare</h3>
      <p>Dacă activitatea necesită înregistrare, alege între:</p>
      <ul>
        <li><strong>Sistem intern</strong> — utilizatorii se înregistrează prin platforma noastră. Poți configura ce câmpuri sunt vizibile și obligatorii (telefon, data nașterii, gen, organizație).</li>
        <li><strong>Link extern</strong> — utilizatorii sunt redirecționați către un formular extern. Un avertisment informează utilizatorii că părăsesc platforma.</li>
      </ul>

      <h3>Configurare câmpuri formular</h3>
      <p>
        Pentru înregistrarea internă, poți alege ce câmpuri apar în formularul de înregistrare și care sunt obligatorii.
        Prenumele, numele și emailul sunt întotdeauna vizibile și obligatorii.
      </p>
      <p>
        <strong>Important:</strong> Configurația câmpurilor nu poate fi modificată după ce activitatea primește prima înregistrare.
      </p>

      <h3>Voluntari</h3>
      <p>Secțiunea Voluntari din formular permite configurarea aplicațiilor de voluntariat. Consultă <a href="/staff/documentatie/voluntari">documentația voluntarilor</a> pentru detalii.</p>
      <ul>
        <li><strong>Deschis pentru aplicații</strong> — voluntarii pot aplica la această activitate.</li>
        <li><strong>Capacitate</strong> — limită maximă de voluntari aprobați.</li>
        <li><strong>Echipe</strong> — echipe cu iconiță, culoare și capacitate proprie.</li>
        <li><strong>Coordonatori</strong> — primesc notificări și pot aproba voluntari.</li>
        <li><strong>Vizibil pentru voluntari</strong> — activitatea apare voluntarilor înainte de publicare.</li>
      </ul>

      <h3>Doar cu invitație</h3>
      <p>
        Dacă înregistrarea e activă, poți marca activitatea ca „doar cu invitație".
        Doar persoanele invitate prin email pot participa.
        Consultă <a href="/staff/documentatie/invitatii">documentația invitațiilor</a> pentru detalii.
      </p>

      <h2>Publicare</h2>
      <p>
        Activitățile au trei niveluri de vizibilitate:
      </p>
      <ul>
        <li><strong>Draft</strong> — invizibilă pentru toți.</li>
        <li><strong>Vizibilă pentru voluntari</strong> — voluntarii o văd, publicul nu.</li>
        <li><strong>Publicată</strong> — vizibilă tuturor.</li>
      </ul>
      <p>
        Toggle-urile sunt disponibile în formularul de editare. Publicarea activează automat vizibilitatea pentru voluntari.
      </p>

      <h2>Restricție tip înregistrare</h2>
      <p>
        Dacă activitatea are înregistrări prin sistemul intern, tipul de înregistrare nu poate fi schimbat la „link extern".
        Aceasta previne pierderea datelor participanților existenți.
      </p>
    </DocLayout>
  );
}
